import { createBrowserRouter } from "react-router-dom";

// Layout and General Pages
import Dashboard from "../Layout/Dashboard";
import ErrorPage from "../pages/ErrorPage/ErrorPage";
// import AdminDashboard from "../pages/Admin/Dashboard";
import ProfilePage from "../components/ProfilePage";
import PharmcyRoute from "./PharmcyRoute";
import AdminRoute from "./AdminRoute";

// Doctor Management
import AllDoctors from "../components/ManageDoctors/AllDoctors/AllDoctors";
import AddDoctor from "../components/ManageDoctors/AddDoctor/AddDoctor";
import EditDoctor from "../components/ManageDoctors/EditDoctor/EditDoctor";
import AddDepartment from "../components/ManageDoctors/AddDepartment/AddDepartment";
import DepartmentList from "../components/ManageDoctors/All Department/All Department";
import EditDepartment from "../components/ManageDoctors/EditDepartment/EditDepartment";

// Patient Management
import AddPatient from "../components/ManagePatients/AddPatient/AddPatient";
import AllPatient from "../components/ManagePatients/AllPatient/AllPatient";
import EditPatient from "../components/ManagePatients/EditPatient/EditPatient";
import UserManagement from "../components/ManagePatients/Manage User/UserManagement";

// Appointment Management
import AddAppointment from "../components/Appointment/AddAppointment/AddAppointment";
import AppointmentList from "../components/Appointment/AppoinmentList/AllAppoinment";
import TodayAppointments from "../components/Appointment/AppoinmentList/TodayAppointments";
import AppointmentLists from "../components/Patient/Appoinment/AllAppoinment";

// Blog Management
import AddBlog from "../components/Blogs/AddBlog/AddBlog";
import BlogList from "../components/Blogs/AllBlog/AllBlog";
import EditBlog from "../components/Blogs/EditBlog/EditBlog";
import AddCategory from "../components/Blogs/Category/AddCategory";
import CategoryList from "../components/Blogs/Category/AllCategory";
import EditCategory from "../components/Blogs/Category/EditCategory";

// Website Management
import HomepageForm from "../components/Manage Section/HomePage";
import AboutPage from "../components/Manage Section/AboutPage";
import DiagnosticPage from "../components/Manage Section/DiagnosticPage";
import ContactPage from "../components/Manage Section/ContactPage";
import Header from "../components/Manage Section/Header";
import Footer from "../components/Manage Section/Footer";
import AddPage from "../components/Manage Page/Add Page/AddPage";
import AllPages from "../components/Manage Page/AllPages/AllPages";
import EditPage from "../components/Manage Page/EditPage/EditPage";

// Reviews and Contact
import AddReviews from "../components/Reviews/AddReviews";
import ContactData from "../components/Contact/ContactData";
import CallbackReqData from "../components/Contact/CallbackReqData";
import EmailConfig from "../components/EmailConfiguration/EmailConfig";
import NotificationPage from "../Layout/Notification";
import UpComing from "../components/Appointment/AppoinmentList/UpComing";
import AmbulanceManager from "../components/Ambulance/AmbulanceManager";
import BirthRecordManager from "../components/BirthAndDeath/BirthRecordManager";
import DeathRecordManager from "../components/BirthAndDeath/DeathRecordManager";
import AmbulanceCallList from "../components/Ambulance/Call/AmbulanceCallList";
import PharmacyBill from "../components/Pharmacy/PharmacyBill";
import PathologyBill from "../components/Pathology/PathologyBill";
import Medicines from "../components/Pharmacy/Medicines";
import ImportMedicines from "../components/Pharmacy/ImportMedicines";
import PurchaseMedicine from "../components/Pharmacy/PurchaseMedicine";
import AddReturn from "../components/Return/AddReturn";
import InvoiceReturnList from "../components/Return/InvoiceReturnList";
import SupplierReturnList from "../components/Return/SupplierReturnList";
import WastageReturnList from "../components/Return/WastageReturnList";
import PathologistRoute from "./PathologistRoute";
import EditReturn from "../components/Return/EditReturn";
import ErrorImage from "../components/Website Setup/ErrorImage/ErrorImage";
import NicuAdmission from "../components/Nicu/NicuAdmission";
import NicuBill from "../components/Nicu/NicuBill/NicuBill";
import NicuAdmittedPatient from "../components/Nicu/NicuAdmittedPatient";
import HospitalAdmittedPatient from "../components/HospitalOffice/HospitalAdmittedPatient";
import HospitalAdmission from "../components/HospitalOffice/HospitalAdmission";
import HospitalBill from "../components/HospitalOffice/HospitalBill/HospitalBill";
import HospitalConfig from "../components/HospitalOffice/HospitalConfig/HospitalConfig";
import NicuInChargeRoute from "./NicuInChargeRoute";
import HospitalManagerRoute from "./HospitalManagerRoute"
import TotalAssets from "../components/StoreManagement/TotalAssets";
import Wastage from "../components/StoreManagement/Wastage";
import StoreAsset from "../components/StoreManagement/StoreAsset";
import NicuConfig from "../components/Nicu/NicuConfig/NicuConfig";
import DoctorRoute from "./DoctorRoute";
import AppointmentAccounts from "../components/Accounts/AppointmentAccounts";
import PathologyAccounts from "../components/Accounts/PathologyAccounts";
import PharmacyAccounts from "../components/Accounts/PharmacyAccounts";
import NicuAccounts from "../components/Accounts/NicuAccounts";
import HospitalAccounts from "../components/Accounts/HospitalAccounts";
import AmbulanceAccounts from "../components/Accounts/AmbulanceAccounts";
import EmergencyAccounts from "../components/Accounts/EmergencyAccounts";
import StoreAccounts from "../components/Accounts/StoreAccounts";
import TotalRevenue from "../components/Accounts/TotalRevenue";
import PharmacyList from "../components/Pharmacy/PharmacyList/PharmacyList";
import Authority from "../components/Website Setup/Authority/Authority";
import EmergencyConfig from "../components/Emergency/EmergencyConfig/EmergencyConfig";
import EmergencyBill from "../components/Emergency/EmergencyBill/EmergencyBill";
import DashboardHome from "../pages/Dashboard/DashboardHome";
import MyPatients from "../components/MyPractise/MyPatients";
import AllAppointments from "../components/MyPractise/AllAppointments";
import BookAppointment from "../components/MyPractise/AddAppointment";
import NewLabReport from "../components/Pathology/NewLabReport";
import LabReportList from "../components/Pathology/LabReportList";
import MyLabReports from "../components/Pathology/MyLabReports";
import PrivateRoute from "./PrivateRoute";
import OfficeDepositList from "../components/HospitalOffice/OfficeAccounts/OfficeDeposits/OfficeDepositList";
import OfficeExpenseList from "../components/HospitalOffice/OfficeAccounts/OfficeExpenses/OfficeExpenseList";
import OfficeAccountSummary from "../components/HospitalOffice/OfficeAccounts/AccountSummary/OfficeAccountSummary";
import OfficeConfig from "../components/HospitalOffice/OfficeAccounts/OfficeConfig/OfficeConfig";
import OutdoorBill from "../components/HospitalOffice/OutdoorBill/OutdoorBill";
import PatientLedger from "../components/Accounts/PatientLedger";
import DoctorLedger from "../components/Accounts/DoctorLedger";
import MyPaymentHistory from "../components/MyPractise/MyPaymentHistory";
import PathologyConfig from "../components/Pathology/PathologyConfig/PathologyConfig";
import ReferLedger from "../components/Pathology/PathologyAccounts/ReferLedger";
import UserCollection from "../components/Pathology/PathologyAccounts/UserCollection";
import PathologyAccountSummary from "../components/Pathology/PathologyAccounts/PathologyAccountSummary";
import PathologyDoctorLedger from "../components/Pathology/PathologyAccounts/PathologyDoctorLedger";
import PathologyOtherExpense from "../components/Pathology/PathologyAccounts/PathologyOtherExpense";
import PathologyDailyClosing from "../components/Pathology/PathologyAccounts/PathologyDailyClosing";
import PathologyMdAccount from "../components/Pathology/PathologyAccounts/PathologyMdAccount";
import PathologyExpertPosting from "../components/Pathology/PathologyAccounts/PathologyExpertPosting";
import NicuOfficeExpenseItemList from "../components/Nicu/NicuOfficeAccounts/OfficeConfig/OfficeExpenses/NicuOfficeExpenseItemList";
import NicuOfficeExpenseList from "../components/Nicu/NicuOfficeAccounts/OfficeConfig/OfficeExpenses/NicuOfficeExpenseList";
import NicuOfficeAccountSummary from "../components/Nicu/NicuOfficeAccounts/AccountSummary/NicuOfficeAccountSummary";
import DiscountUserList from "../components/Nicu/DiscountUsers/DiscountUserList";
import NicuReferLedger from "../components/Nicu/ReferLedger/NicuReferLedger";
import NicuDiscountReport from "../components/Nicu/DiscountReport/NicuDiscountReport";
import NicuAdvancePayment from "../components/Nicu/AdvancePayment/NicuAdvancePayment";
import NicuXrayType from "../components/Nicu/Xray/NicuXrayType";
import NicuXray from "../components/Nicu/Xray/NicuXray";
import MonthEndReferReport from "../components/Pathology/PathologyAccounts/MonthEndReferReport";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Dashboard />,
    errorElement: <ErrorPage />,
    children: [
      // Dashboard
      {
        path: "/",
        element:<DashboardHome/>,
      },
      // Doctor Management Routes
      {
        path: "all-doctors",
        element: <DoctorRoute component={AllDoctors} />,
      },
      {
        path: "add-doctor",
        element: <DoctorRoute component={AddDoctor} />,
      },
      {
        path: "/edit-doctor/:id",
        element: <DoctorRoute component={EditDoctor} />,
      },
      {
        path: "add-department",
        element: <DoctorRoute component={AddDepartment} />,
      },
      {
        path: "all-department",
        element: <DoctorRoute component={DepartmentList} />,
      },
      {
        path: "/edit-department/:id",
        element: <DoctorRoute component={EditDepartment} />,
      },

      // Patient Management Routes
      {
        path: "add-patient",
        element: <AdminRoute component={AddPatient} />,
      },
      {
        path: "all-patients",
        element: <AdminRoute component={AllPatient} />,
      },
      {
        path: "/edit-patient/:id",
        element: <AdminRoute component={EditPatient} />,
      },
      {
        path: "user-management",
        element: <AdminRoute component={UserManagement} />,
      },

      // Pharmacy & Medicines Management
      {
        path: "pharmacy-bill",
        element: <PharmcyRoute component={PharmacyBill} />,
      },
      {
        path: "medicines",
        element: <PharmcyRoute component={Medicines} />,
      },
      {
        path: "import-medicines",
        element: <PharmcyRoute component={ImportMedicines} />,
      },
      {
        path: "purchase-medicine",
        element: <PharmcyRoute component={PurchaseMedicine} />,
      },
      {
        path: "pharmacy-list",
        element: <PharmcyRoute component={PharmacyList} />,
      },

      // Return
      {
        path: "add-return",
        element: <PharmcyRoute component={AddReturn} />,
      },
      {
        path:"/edit-return/:type/:id",
        element: <AdminRoute component={EditReturn} />,
      },
      {
        path: "invoice-return-list",
        element: <PharmcyRoute component={InvoiceReturnList} />,
      },
      {
        path: "supplier-return-list",
        element: <PharmcyRoute component={SupplierReturnList} />,
      },
      {
        path: "wastage-return-list",
        element: <PharmcyRoute component={WastageReturnList} />,
      },

      // Review Management
      {
        path: "add-reviews",
        element: <AddReviews />,
      },

      // Appointment Management Routes
      {
        path: "upcoming-appointments",
        element: <DoctorRoute component={UpComing} />,
      },
      {
        path: "add-appointment",
        element: <DoctorRoute component={AddAppointment} />,
      },
      {
        path: "all-appointments",
        element: <DoctorRoute component={AppointmentList} />,
      },
      {
        path: "my-appointment",
        element: <AppointmentLists/>,
      },
      {
        path: "todays-appointments",
        element: <DoctorRoute component={TodayAppointments} />,
      },

      // My Practise Routes
      {
        path: "my-patients",
        element: <DoctorRoute component={MyPatients} />,
      },
      {
        path: "my-appointments",
        element: <DoctorRoute component={AllAppointments} />,
      },
      {
        path: "book-appointment",
        element: <DoctorRoute component={BookAppointment} />,
      },
      {
        path: "my-payments",
        element: <DoctorRoute component={MyPaymentHistory} />,
      },
      // Blog Management Routes
      {
        path: "all-blog",
        element: <AdminRoute component={BlogList} />,
      },
      {
        path: "add-blog",
        element: <AdminRoute component={AddBlog} />,
      },
      {
        path: "add-category",
        element: <AdminRoute component={AddCategory} />,
      },
      {
        path: "all-category",
        element: <AdminRoute component={CategoryList} />,
      },
      {
        path: "/edit-category/:id",
        element: <AdminRoute component={EditCategory} />,
      },
      {
        path: "/edit-blog/:id",
        element: <AdminRoute component={EditBlog} />,
      },
      // Pathology Management Routes
      {
        path: "/pathology-bill",
        element: <PrivateRoute component={PathologyBill} />,
      },
      {
        path: "/pathology-config",
        element: <PathologistRoute component={PathologyConfig} />,
      },
      {
        path: "/pathology-lab-test",
        element: <PathologistRoute component={NewLabReport} />,
      },
      {
        path: "/pathology-reports",
        element: <PathologistRoute component={LabReportList} />,
      },
      {
        path: "/my-reports",
        element: <PrivateRoute component={MyLabReports} />, 
      },
      {
        path: "/pathology/refer-ledger",
        element: <PathologistRoute component={ReferLedger} />,
      },
      {
        path: "/pathology/user-collection",
        element: <PathologistRoute component={UserCollection} />,
      },
      {
        path: "/pathology/account-summary",
        element: <PathologistRoute component={PathologyAccountSummary} />,
      },
      {
        path: "/pathology/doctor-ledger",
        element: <PathologistRoute component={PathologyDoctorLedger} />,
      },
      {
        path: "/pathology/expert-posting",
        element: <PathologistRoute component={PathologyExpertPosting} />,
      },
      {
        path: "/pathology/others-expense",
        element: <PathologistRoute component={PathologyOtherExpense} />,
      },
      {
        path:"/pathology/monthly-reports",
        element: <PathologistRoute component={MonthEndReferReport} />,
      },
      {
        path:"/pathology/daily-closing",
        element: <PathologistRoute component={PathologyDailyClosing} />,
      },
      {
        path:"/pathology/md-account",
        element: <PathologistRoute component={PathologyMdAccount} />,
      },
      
      // Nicu
      {
        path: "/nicu-patients",
        element: <NicuInChargeRoute component={NicuAdmittedPatient} />,
      },
      {
        path: "/nicu-admission",
        element: <NicuInChargeRoute component={NicuAdmission} />,
      },
      {
        path: "/nicu-bill",
        element: <NicuInChargeRoute component={NicuBill} />,
      },
      {
        path: "/nicu-config",
        element: <NicuInChargeRoute component={NicuConfig} />,
      },
      {
        path: "/nicu-office-expense-items",
        element: <NicuInChargeRoute component={NicuOfficeExpenseItemList} />,
      },
      {
        path: "/nicu-office-expense",
        element: <NicuInChargeRoute component={NicuOfficeExpenseList} />,
      },
      {
        path: "/nicu-account-summary",
        element: <NicuInChargeRoute component={NicuOfficeAccountSummary} />,
      },
      {
        path:"/nicu-discount-users",
        element: <NicuInChargeRoute component={DiscountUserList} />,
      },
      {
        path:"/nicu-refer-ledger",
        element: <NicuInChargeRoute component={NicuReferLedger} />,
      },
      {
        path:"/nicu-discount-report",
        element: <NicuInChargeRoute component={NicuDiscountReport} />,
      },
      {
        path:"/nicu-xray-type",
        element: <NicuInChargeRoute component={NicuXrayType} />,
      },
      {
        path:"/nicu-xray",
        element: <NicuInChargeRoute component={NicuXray} />,
      },
      {
        path:"/nicu-advance-payment",
        element: <NicuInChargeRoute component={NicuAdvancePayment} />,
      },
      
      {
        path: "/emergency-bill",
        element: <HospitalManagerRoute component={EmergencyBill} />,
      },
      {
        path: "/emergency-config",
        element: <HospitalManagerRoute component={EmergencyConfig} />,
      },
      // Hospital Office
      {
        path: "/hospital-patients",
        element: <HospitalManagerRoute component={HospitalAdmittedPatient} />,
      },
      {
        path: "/hospital-admission",
        element: <HospitalManagerRoute component={HospitalAdmission} />,
      },
      {
        path: "/hospital-bill",
        element: <HospitalManagerRoute component={HospitalBill} />,
      },
      {
        path: "/hospital-config",
        element: <HospitalManagerRoute component={HospitalConfig} />,
      },
      {
        path: "/outdoor-bill",
        element: <HospitalManagerRoute component={OutdoorBill} />,
      },
      {
        path: "/office-deposits",
        element: <HospitalManagerRoute component={OfficeDepositList} />,
      },
      {
        path: "/office-expenses",
        element: <HospitalManagerRoute component={OfficeExpenseList} />,
      },
      {
        path: "/office-account-summary",
        element: <HospitalManagerRoute component={OfficeAccountSummary} />,
      },
      {
        path: "/office-config",
        element: <HospitalManagerRoute component={OfficeConfig} />,
      },
      // Store Management
      {
        path: "/total-assets",
        element: <AdminRoute component={TotalAssets} />,
      },
      {
        path: "/wastage",
        element: <AdminRoute component={Wastage} />,
      },
      {
        path: "/store-asset",
        element: <AdminRoute component={StoreAsset} />,
      },
      // Accounts
      {
        path: "/accounts/patient-ledger",
        element: <PrivateRoute component={PatientLedger} />,
      },
      {
        path: "/accounts/doctor-ledger",
        element: <PrivateRoute component={DoctorLedger} />,
      },
      {
        path: "/accounts/appointment",
        element: <AdminRoute component={AppointmentAccounts} />,
      },
      {
        path: "/accounts/pathology",
        element: <AdminRoute component={PathologyAccounts} />,
      },
      {
        path: "/accounts/pharmacy",
        element: <AdminRoute component={PharmacyAccounts} />,
      },
      {
        path: "/accounts/nicu",
        element: <AdminRoute component={NicuAccounts} />,
      },
      {
        path: "/accounts/hospital",
        element: <AdminRoute component={HospitalAccounts} />,
      },
      {
        path: "/accounts/ambulance",
        element: <AdminRoute component={AmbulanceAccounts} />,
      },
      {
        path: "accounts/emergency",
        element: <AdminRoute component={EmergencyAccounts} />,
      },
      {
        path: "accounts/store",
        element: <AdminRoute component={StoreAccounts} />,
      },
      {
        path: "/accounts/revenue",
        element: <AdminRoute component={TotalRevenue} />,
      },
      // Ambulance Management Routes
      {
        path: "/ambulance",
        element: <AdminRoute component={AmbulanceManager} />,
      },
      {
        path: "/ambulance-call",
        element: <AdminRoute component={AmbulanceCallList} />,
      },
      // Birth & Death Management Routes
      {
        path: "/birth",
        element: <AdminRoute component={BirthRecordManager} />,
      },
   
      {
        path: "/death",
        element: <AdminRoute component={DeathRecordManager} />,
      },
      
      // Website Management Routes
      {
        path: "cookie-consent",
        element: <AdminRoute component={() => <h1>Add doctor</h1>} />, // Placeholder
      },
      {
        path: "error-page",
        element: <AdminRoute component={ErrorImage}/>
      },
      {
        path: "authority-page",
        element: <AdminRoute component={Authority}/>
      },
      {
        path: "settings",
        element: <AdminRoute component={() => <h1>Add doctor</h1>} />, // Placeholder
      },
      {
        path: "/notifications",
        element: <AdminRoute component={NotificationPage} />,
      },
      {
        path: "email-config",
        element: <AdminRoute component={EmailConfig} />, // Placeholder
      },
      {
        path: "email-template",
        element: <AdminRoute component={() => <h1>Add doctor</h1>} />, // Placeholder
      },
      {
        path: "home-page",
        element: <AdminRoute component={HomepageForm} />,
      },
      {
        path: "about-page",
        element: <AdminRoute component={AboutPage} />,
      },
      {
        path: "diagnostic-page",
        element: <AdminRoute component={DiagnosticPage} />,
      },
      {
        path: "contact-page",
        element: <AdminRoute component={ContactPage} />,
      },
      {
        path: "header",
        element: <AdminRoute component={Header} />,
      },
      {
        path: "footer",
        element: <AdminRoute component={Footer} />,
      },
      {
        path: "add-page",
        element: <AdminRoute component={AddPage} />,
      },
      {
        path: "all-page",
        element: <AdminRoute component={AllPages} />,
      },
      {
        path: "/edit-page/:id",
        element: <AdminRoute component={EditPage} />,
      },
      
      // Other Routes
      {
        path: "cache-clear",
        element: <AdminRoute component={() => <h1>Add doctor</h1>} />, // Placeholder
      },
      {
        path: "profile",
        element: <ProfilePage/>,
      },
      {
        path: "contact",
        element: <AdminRoute component={ContactData} />,
      },
      {
        path: "callback",
        element: <AdminRoute component={CallbackReqData} />,
      },
    ],
  },
]);